import * as React from "react";
import { ExpandingSearch } from "@/components/ui/expanding-search";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { OrderFilters } from "@/components/orders/OrderFilters";
import { DateRange } from "@/hooks/useOrdersQuery";
import { Location, Customer } from "@/types/tms";

interface AssetScheduleFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statusFilter: string[];
  onStatusFilterChange: (value: string[]) => void;
  customerFilter: string[];
  onCustomerFilterChange: (value: string[]) => void;
  orderTypeFilter: string;
  onOrderTypeFilterChange: (value: string) => void;
  tripTypeFilter: string[];
  onTripTypeFilterChange: (value: string[]) => void;
  shipFromFilter: string[];
  onShipFromFilterChange: (value: string[]) => void;
  shipToFilter: string[];
  onShipToFilterChange: (value: string[]) => void;
  locations: Location[];
  customers: Customer[];
  isProd: boolean;
  subscribedOnly: boolean;
  onSubscribedOnlyChange: (value: boolean) => void;
  dateFilter: DateRange;
  onDateFilterChange: (value: DateRange) => void;
  legendButton?: React.ReactNode;
}

export function AssetScheduleFilters({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  customerFilter,
  onCustomerFilterChange,
  orderTypeFilter,
  onOrderTypeFilterChange,
  tripTypeFilter,
  onTripTypeFilterChange,
  shipFromFilter,
  onShipFromFilterChange,
  shipToFilter,
  onShipToFilterChange,
  locations,
  customers,
  isProd,
  subscribedOnly,
  onSubscribedOnlyChange,
  dateFilter,
  onDateFilterChange,
  legendButton,
}: AssetScheduleFiltersProps) {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <OrderFilters
        statusFilter={statusFilter}
        onStatusFilterChange={onStatusFilterChange}
        dateFilter={dateFilter}
        onDateFilterChange={onDateFilterChange}
        shipFromFilter={shipFromFilter}
        onShipFromFilterChange={onShipFromFilterChange}
        shipToFilter={shipToFilter}
        onShipToFilterChange={onShipToFilterChange}
        locations={locations}
        customerFilter={customerFilter}
        onCustomerFilterChange={onCustomerFilterChange}
        customers={customers}
        tripTypeFilter={tripTypeFilter}
        onTripTypeFilterChange={onTripTypeFilterChange}
        orderTypeFilter={orderTypeFilter}
        onOrderTypeFilterChange={onOrderTypeFilterChange}
        isProd={isProd}
        searchQuery={searchQuery}
        onClearSearch={() => onSearchChange("")}
      />

      <div className="ml-auto flex items-center gap-2">
        <div className="flex items-center gap-2">
          <Switch
            id="subscribed-only"
            checked={subscribedOnly}
            onCheckedChange={onSubscribedOnlyChange}
          />
          <Label htmlFor="subscribed-only" className="text-xs text-muted-foreground cursor-pointer whitespace-nowrap">
            Subscribed orders only
          </Label>
        </div>
        {legendButton}
        <ExpandingSearch value={searchQuery} onChange={onSearchChange} placeholder="Search tractors or orders..." />
      </div>
    </div>
  );
}
